import { joinAndAddKeys } from '../util';

export const getTeamUsers = (state, team) => {
  if (team) {
    return joinAndAddKeys(team.members, state.users.items);
  }
  return [];
};